<template>
  <div class="theme-hero-area">
    <div class="theme-hero-area-bg-wrap">
      <div
        class="theme-hero-area-bg"
        :style="{'background-image': 'url(' + require('@/assets/img/bg-home.jpg') + ')'}"></div>
      <div class="theme-hero-area-bg theme-hero-grad-mask"></div>
    </div>
    <div class="theme-hero-area-body">
      <div class="theme-page-section theme-page-section-xl">
        <div class="container">
          <div class="row">
            <div class="col-md-4 col-md-offset-4">
              <span class="center-block mt-20 _mb-30">
                <img
                  class="img-responsive"
                  src="@/assets/img/logo-experience.png"
                  alt="Logo Tour House"
                  title="Tour House">
              </span>
              <div class="col-md-12 theme-login-white">
                <h1 class="theme-login-title theme-login-title-white text-center mb-20 h2">Cadastrar nova senha</h1>
              </div>
            </div>
            <div class="col-md-6 col-md-offset-3">
              <div class="theme-login theme-login-white">
                <div class="theme-login-box">
                  <div class="theme-login-box-inner">
                    <form @submit.prevent="handleSubmit">
                      <p class="theme-login-pwd-reset-text">Digite sua nova senha abaixo:</p>
                      <div class="form-group theme-login-form-group">
                        <input
                          @focus="open_helper = true"
                          class="form-control"
                          type="password"
                          placeholder="Nova senha"
                          name="password1"
                          v-model="password1"
                          v-validate="expression.password"
                          ref="password1"
                          :class="{ 'alert-danger': errors.has('password1') }">
                        <span class="error-message-forms">{{ errors.first('password1') }}</span>
                      </div>
                      <div class="form-group theme-login-form-group">
                        <input
                          @focus="open_helper = true"
                          class="form-control"
                          type="password"
                          placeholder="Confirmar nova senha"
                          name="password2"
                          v-model="password2"
                          v-validate="expression.passwordConfirmation"
                          data-vv-as="password1"
                          :class="{ 'alert-danger': errors.has('password2') }">
                        <span class="error-message-forms">{{ errors.first('password2') }}</span>
                      </div>

                      <password-helper v-if="open_helper" />

                      <button class="btn btn-uc btn-dark btn-block btn-lg" href="#" type="submit">
                        <i class="fa fa-check" aria-hidden="true"></i> Alterar senha
                      </button>

                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import expression from '@/validate/expression';
import PasswordHelper from '@/components/PasswordHelper';

export default {
  components: {
    PasswordHelper
  },
  data() {
    return {
      password1: '',
      password2: '',
      submitted: false,
      open_helper: false,
      /**/
      expression: {
        password: { ...expression.password },
        passwordConfirmation: { ...expression.password, confirmed: 'password1' }
      }
    };
  },
  methods: {
    ...mapActions('user', [
      'postPasswordReset',
      'postSetPassword'
    ]),

    handleSuccess (response) {
      if (typeof response.data.error == 'undefined') {
        this.$swal({
          title: response.data.message,
          type: 'success',
          showConfirmButton: false,
          timer: 3000,
          onClose: () => {
            this.$router.push('/login');
          }
        });
      } else {
        this.handleError(response.data.error)
      }
      this.submitted = false;
    },

    handleError (error) {
      this.$swal({
        title: (error.response.data) ? error.response.data : 'Ocorreu um erro ao alterar a senha. Tente novamente.',
        type: 'error',
        confirmButtonText: 'SAIR'
      });
      this.submitted = false;
    },

    handleSubmit () {
      const { user, token } = this.$route.query;

      this.$validator.validateAll()
        .then(result => {

          if (!result) return false;

          this.submitted = true;
          this.postPasswordReset({ user, token })
            .then(() => {
              this.postSetPassword({
                user,
                data: {
                  new_password1: this.password1,
                  new_password2: this.password2
                }
              })
                .then(this.handleSuccess)
            })
            .catch(this.handleError)
      });
    }
  }
};

</script>

<style scoped>
.theme-hero-area {
  min-height: 100vh;
  height: auto;
}
</style>
